import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../../../services/notification.service';
import { FormularioService } from './../../../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { endWith, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-pc003-card-I',
  templateUrl: './pc003-card-I.component.html'
})

export class Pc003CardIComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;

  
  // tslint:disable-next-line: max-line-length
  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
    super('Dados', false);

    this.formulario = this.formBuilder.group({
        id: [null, []],
        contrato_juridico: ['', []],
        cooperante: ['', []],
        hibrido_rnc: ['', []],
        site_origem: ['', []],
        gleba: ['', []],
        distancia_campo: ['', []],
        especie: ['', []],
        tipo_colheita: ['', []],
        numero_campo: ['', []],
        safra: ['', []],
        ano: ['', []],
        jit: ['', []],
        contrato_torre: ['', []],
        geracao: ['', []],
        origem_contrato: ['', []],
        janela_plantio: ['', []],
        ambiente: ['', []],
        site_recebimento: ['', []],
    });
  }

  async ngOnInit(): Promise<void> {
    await Promise.all([this.getLists()]);
  }

  async getLists(): Promise<void> {
    await Promise.all([]);
  }

  changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }


}


